<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'Match options' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item>
      <ion-text color="dark">
        {{ participantSide1 }} - {{ participantSide2 }}
      </ion-text>
    </ion-item>

    <ion-item-divider>
      <ion-label>{{ 'Tracking Options' | translate }}</ion-label>
    </ion-item-divider>

    @for (item of trackingOptions; track $index) {
    <ion-item
      button
      [disabled]="item.disabled"
      [hidden]="!item.show"
      (click)="dismiss(item.action)"
      [lines]="item.lines"
    >
      <ion-label
        >{{ item.name }}
        <ion-text color="danger" class="ion-text-wrap">
          <p>{{ item.warning }}</p>
        </ion-text>
        <ion-text color="gray" class="ion-text-wrap">
          <p>{{ item.helper }}</p>
        </ion-text>
      </ion-label>
      <ion-icon slot="start" [color]="item.color" [name]="item.icon"></ion-icon>
    </ion-item>
    }

    <ion-item-divider>
      <ion-label>{{ 'Settings' | translate }}</ion-label>
    </ion-item-divider>

    @for (item of items; track $index) {
    <ion-item
      button
      [hidden]="!item.show"
      (click)="dismiss(item.action)"
      [lines]="item.lines"
      detail="false"
    >
      <ion-label
        >{{ item.name }}
        <ion-text color="gray" class="ion-text-wrap">
          <p>{{ item.helper }}</p>
        </ion-text>
      </ion-label>
      <ion-icon slot="start" [color]="item.color" [name]="item.icon"></ion-icon>
    </ion-item>
    }
  </ion-list>
</ion-content>
